const config = {
    ENDPOINT: 'https://dangerousgoods-test.usps.com/dangerous-ws',  
    BASE_URL: '/dangerous-goods-web',
    LOGIN: 'external'
  }

  export default config